import { SIZE_33 } from '@/lib/gridElements/size';

//kpis
import { profileVisitsConfig } from '@/lib/analytics/kpis/instagram/profileVisits';
import { websiteClicksConfig } from '@/lib/analytics/kpis/instagram/websiteClicks';
import { directionsClicksConfig } from '@/lib/analytics/kpis/instagram/directionsClicks';
import { emailClicksConfig } from '@/lib/analytics/kpis/instagram/emailClicks';
import { phoneClicksConfig } from '@/lib/analytics/kpis/instagram/phoneClicks';
import { textMsgClicksConfig } from '@/lib/analytics/kpis/instagram/textMsgClicks';
import { directionsClicksRateConfig } from '@/lib/analytics/kpis/instagram/directionsClicksRate';
import { emailClicksRateConfig } from '@/lib/analytics/kpis/instagram/emailClicksRate';
import { websiteClicksRateConfig } from '@/lib/analytics/kpis/instagram/websiteClicksRate';
//charts
import { directionsClicksHistoryConfig } from '@/lib/analytics/charts/instagram/directionsClicksHistory';
import { emailClicksHistoryConfig } from '@/lib/analytics/charts/instagram/emailClicksHistory';
import { websiteClicksHistoryConfig } from '@/lib/analytics/charts/instagram/websiteClicksHistory';
import { profileVisitsHistoryConfig } from '@/lib/analytics/charts/instagram/profileVisitsHistory';

export const ProfileActivityInstagram = [
    // line1
    { ...profileVisitsConfig, size: SIZE_33 },
    { ...websiteClicksConfig, size: SIZE_33 },
    { ...directionsClicksConfig, size: SIZE_33 },

    // line2
    { ...emailClicksConfig, size: SIZE_33 },
    { ...phoneClicksConfig, size: SIZE_33 },
    { ...textMsgClicksConfig, size: SIZE_33 },

    //line3
    profileVisitsHistoryConfig,
    websiteClicksHistoryConfig,

    //line4
    emailClicksHistoryConfig,
    directionsClicksHistoryConfig,

    //line5
    { ...websiteClicksRateConfig, size: SIZE_33 },
    { ...emailClicksRateConfig, size: SIZE_33 },
    { ...directionsClicksRateConfig, size: SIZE_33 }
];

export const requestInstagramParams = [
    // InstagramAccountMetrics
    [
        'profile_visits',
        'website_clicks',
        'directions_clicks',
        'email_clicks',
        'phone_call_clicks',
        'text_message_clicks',
        'profile_visits_history'
    ],
    [
        'website_clicks_history',
        'email_clicks_history',
        'directions_clicks_history',
        'website_clicks_rate',
        'email_clicks_rate',
        'directions_clicks_rate'
    ]
];
